// Copyright (c) Ping. All rights reserved.

import { useCallback } from 'react';

import { type CallKind,useConversations } from '@ping/ui';

import { useCallStore } from '@calls/store/callStore';
import { log } from '@core/log/log';
import { CallHistoryHome } from '@features/calls/CallHistoryHome';

/**
 * Calls pane — Figma file Y95LG1oFzU2PHIvFuMYTfJ → Calls page
 * (2804:79061) + Call History sub-page (2524:64912). The previous
 * <CallHistoryScreen/> from @ping/ui was StyleSheet-based and didn't
 * match the Figma dark-mode look; this host renders the new
 * Tailwind-native CallHistoryHome instead.
 */
export function CallsRouteHost(): JSX.Element {
  const { conversations } = useConversations();

  const handleStartCall = useCallback(
    (userId: string, kind: CallKind) => {
      // Find the 1:1 conversation with this peer so we can send the
      // call_invite on the right MLS conversation.
      const conv = conversations.find(
        (c) => c.kind === 'direct' && c.peerAccountId === userId,
      );
      if (conv === undefined) {
        log.warn({ event: 'calls.start.no_conv', userId });
        return;
      }
      const displayName = conv.name ?? userId;
      void useCallStore.getState().startCall({
        conversationId: conv.id,
        media: kind,
        title: displayName,
        isGroup: false,
        peerAccountIds: [userId],
        peerDisplayNames: { [userId]: displayName },
        ...(conv.avatarUri !== undefined ? { avatarUri: conv.avatarUri } : {}),
      });
    },
    [conversations],
  );

  return (
    <div className="flex flex-col w-full h-screen min-h-0">
      <CallHistoryHome onStartCall={handleStartCall} />
    </div>
  );
}
